import React, { useEffect } from "react"
import { Slice } from "gatsby"
import { sectionFadeInUp } from "./animationFunc"
// import Header from "./header"
// import Footer from "./footer"

const Layout = ({ page, children }) => {
  useEffect(() => {
    document.querySelectorAll(".section-fadein-up").forEach((v) => {
      v.querySelectorAll(".fadein-up").forEach((el, i) => {
        el.classList.remove("invisible")
        el.setAttribute("data-delay", i * 0.2)
        sectionFadeInUp(v, el)
      })
    })
  })

  return (
    <div className="relative">
      
      {page?.template?.templateName === "Rewards Template" ? (
        <Slice alias="header-rewards" slug={page.slug} locale={page.locale} />
      ) : (
        <Slice alias="header" slug={page.slug} locale={page.locale} />
      )}

      {/* <Header slug={page.slug} locale={page.locale} /> */}
      {children}
      {/* <Footer slug={page.slug} locale={page.locale} /> */}
      <Slice alias="footer" slug={page.slug} locale={page.locale} />
    </div>
  )
}

export default Layout
